import Occasion from '@support/Occasion';
import Starred from '../../Models/Starred';
import type { ReduxAction } from '../../types';

export function starredReducer(state: Starred = new Starred(), { type, payload }: ReduxAction) {
  switch (type) {
    case 'LOAD_LOCAL_STORE_SUCCEEDED':
      const storedLists = payload.get('groups');
      const storedStarredList = storedLists
        ? storedLists.find(({ slug }) => slug === 'starred')
        : null;

      if (!state.isLoaded && storedStarredList) {
        return state.copyWith({ ids: storedStarredList.contact_ids });
      } else {
        return state;
      }

    case 'FETCH_STARRED_SUCCEEDED':
      return state.copyWith({ ids: payload.response, updated: new Occasion() });

    case 'UPDATE_GROUP_REQUESTED':
    case 'UPDATE_GROUP_SUCCEEDED':
      if (payload.slug !== 'starred') {
        return state;
      }

      return state.copyWith({ ids: payload.memberIDs.toArray() });

    default:
      return state;
  }
}
